 import React from "react";
import LinkLine from "../../Utils/LinkLine";
import ImageSlider from "../../Utils/ImageSlider";
import Dot from "../../Utils/Dot";
import About from "../../Pages/About";
import AboutSection from "../Common/AboutSection";

const OrganAffected = () => {
  return (
    <>

     <AboutSection/>
      <section className="border-0 border-[#2d95a5] pt-4 pr-4 pl-4 rounded-lg mt-11 bg-white bg-opacity-50 mb-5">
        <h2 className="text-[#2d95a5] font-bold text-xl md:text-2xl text-center mb-2 md:mb-5 uppercase"> 
        ORGANS AFFECTED BY  DIABETES 
        </h2> 
        <div className="transform md:scale-100 mb-[-60px] mt-[-70px] md:mt-0">
          <ImageSlider />
          {/* <img
              src="../assets/aa.png"
              alt="Banner"
              className="mx-auto float-right max-w-full md:max-w-md lg:max-w-xl xl:max-w-2xl relative"
            /> */}
          {/* <img src="../assets/organ.png" alt="Logo" className="w-full h-full" /> */}
        </div>

        
      </section>
    </>
  );
};

export default OrganAffected;
